// extracted by mini-css-extract-plugin
export default {"container":"Route_container__2+3zf"};